import React, { useState, useEffect } from 'react';
import {
  useFirebaseContext,
  useActiveListContext,
  useTaskContext,
  useAllInOneContext,
} from '../../../context';
import { IndividualTask } from './individual-task';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { isKeyList } from '../../../helpers';
import { Core } from '../..';
import { timestamp } from '../../../lib';

export const Tasks = ({
  forMobile = false,
  setProgress,
  isInDelete,
  setIsInDelete,
}) => {
  const { firebase } = useFirebaseContext();
  const { lists, setMaxModifiedAt } = useAllInOneContext();
  const { activeList } = useActiveListContext();
  const { tasks, setTasks } = useTaskContext();
  const [showTasks, setShowTasks] = useState(false);
  const [targetTask, setTargetTask] = useState(false);
  
  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    let items = tasks;
    const [reorderItem] = items.splice(result.source.index, 1);
    const taskDB = firebase
      .firestore()
      .collection('users')
      .doc(firebase.auth().currentUser.uid)
      .collection('tasks');
    const tempModifiedAt = timestamp.now().toMillis();

    items.splice(result.destination.index, 0, reorderItem);

    items.map((item, index) => {
      if (item.order != index) {
        item.order = index;
        item.modifiedAt = tempModifiedAt;

        taskDB.doc(item.docID).update({
          order: index,
          modifiedAt: tempModifiedAt,
        });
      }
    });

    setMaxModifiedAt(tempModifiedAt);
    setTasks(items);
  };

  useEffect(() => {
    if (lists) {
      if (lists.length > 0) setShowTasks(true);
      else setShowTasks(false);
    }
  }, [lists]);

  return (
    <>
      {tasks && tasks.length > 0 ? (
        !isKeyList(activeList) ? (
          showTasks &&
          tasks && (
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId='tasks'>
                {(provided) => (
                  <Core.List
                    forMobile={forMobile}
                    {...provided.droppableProps}
                    forwardedRef={provided.innerRef}
                  >
                    {tasks.map((task, index) => (
                      <Draggable
                        key={task.docID}
                        draggableId={task.docID}
                        index={task.order}
                      >
                        {(provided, snapshot) => (
                          <div
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            ref={provided.innerRef}
                          >
                            <IndividualTask
                              taskTotal={tasks.length}
                              task={task}
                              dragSnapshot={snapshot}
                              taskIndex={index}
                              setProgress={setProgress}
                              isInDelete={isInDelete}
                              setIsInDelete={setIsInDelete}
                              targetTask={targetTask}
                              setTargetTask={setTargetTask}
                            />
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Core.List>
                )}
              </Droppable>
            </DragDropContext>
          )
        ) : (
          showTasks &&
          tasks && (
            <Core.List forMobile={forMobile}>
              {tasks.map((task, index) => (
                <div key={task.docID}>
                  <IndividualTask
                    taskTotal={tasks.length}
                    task={task}
                    taskIndex={index}
                    isKey={true}
                    setProgress={setProgress}
                    isInDelete={isInDelete}
                    setIsInDelete={setIsInDelete}
                    targetTask={targetTask}
                    setTargetTask={setTargetTask}
                  />
                </div>
              ))}
            </Core.List>
          )
        )
      ) : (
        <div
          style={{
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <span style={{ color: 'rgba(0,0,0,0.45)' }}>No Tasks</span>
        </div>
      )}
    </>
  );
};
